module.exports = __webpack_public_path__ + "img/img@2x_副本.b7b95352.webp";